// extracted by mini-css-extract-plugin
export default {"notificationTitle":"RentalDetailsContent_notificationTitle__VgIi4","notificationText":"RentalDetailsContent_notificationText__+cIxu","aside":"RentalDetailsContent_aside__XBi3H"};